import { SelectionModel } from '@angular/cdk/collections';
import { createAction, props } from '@ngrx/store';
import { TodoItemFlatNode } from 'src/app/catalogue/folders/folders.component';

export const setFolderSelectionList = createAction(
  'SET_FOLDER_SELECTION_LIST',
  props<SelectionModel<TodoItemFlatNode>>()
);
